import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { IDropdownItem, SimpleResult } from "@ryde/shared";

import { landingRoutesApiConst } from "../constants";
import { landingCompanyIdSelector } from "../selectors";
import { useLandingApiMethods } from "./use-landing-api-methods";

export const useLandingApiUnits = () => {
  const companyId = useRecoilValue(landingCompanyIdSelector);
  const unitsUrl = landingRoutesApiConst.units(companyId as number);
  const stationsUrl = landingRoutesApiConst.stations(companyId as number);
  const { apiGet, apiPost } = useLandingApiMethods();

  const getUnitsDropdownItems = useEvent(
    async (): Promise<SimpleResult<IDropdownItem[]> | undefined> => {
      const response = await apiGet<SimpleResult<IDropdownItem[]>>(
        unitsUrl.getDropdownItems,
      );

      return response?.data;
    },
  );

  const getStationsDropdownItems = useEvent(
    async ({
      isDestination = false,
      isOfficial = true,
    }: {
      isOfficial?: boolean;
      isDestination?: boolean;
    }): Promise<SimpleResult<IDropdownItem[]> | undefined> => {
      const response = await apiPost<SimpleResult<IDropdownItem[]>>(
        stationsUrl.getDropdownItems,
        { isDestination, isOfficial },
      );

      return response?.data;
    },
  );

  return { getUnitsDropdownItems, getStationsDropdownItems };
};
